import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "container" ]

  toggleAll(changeEvt){
    this.containerTarget.querySelectorAll('input[type="checkbox"]').forEach(c => c.checked = changeEvt.target.checked)
  }
}
